import { CutStatus } from '@consts/cut';
import { CutType } from '@api/cut';

export enum CutFilterOptions {
    CutType = 'type',
    Material = 'materialIds',
    Country = 'countryName',
    Company = 'companyIds',
    Reseller = 'resellerIds',
    Location = 'locationIds',
    Status = 'status',
    Category = 'category',
    Station = 'stationIds'
}

export type CutFilter = {
    [key in CutFilterOptions]: { [key: string]: boolean };
};

export interface Cut {
    dbCutId: string;
    cutId: string;
    cutType: string;
    creditId: string;
    batchId: string;
    cutStatus: CutStatus;
    cutDate: string;
    syncDate: string;
    country: string;
    materialId: number;
    locationId: number;
    resellerId: number;
    manufacturer: string;
    model: string;
    coverage: string;
    companyID: number;
    totalCutsInQuery: string;
    employeeEmail: string | null;
    category: string;
    stationId: number | null;
    serialNum: string | null;
}

export interface ParsedCut {
    dbCutId: string;
    cutId: string;
    creditId: string;
    batchId: string;
    cutType: CutType;
    cutStatus: CutStatus;
    cutDate: string;
    syncDate: string;
    country: string;
    material: string;
    location: string;
    reseller: string;
    manufacturer: string;
    model: string;
    coverage: string;
    company: string;
    totalCutsInQuery: string;
    locationId: string;
    employeeEmail: string | null;
    category: string;
    stationId: string | null;
    serialNum: string | null;
    // Raw IDs for linking to manage pages
    locationIdRaw: number;
    resellerIdRaw: number;
    companyIdRaw: number;
    stationIdRaw: number | null;
}

export const CutTypeMap = {
    [CutType.Successful]: [
        CutStatus.Invoiced,
        CutStatus.NotYetInvoiced,
        CutStatus.Void,
        CutStatus.Credit,
        CutStatus.Credited,
    ],
    [CutType.Warranty]: [
        CutStatus.Pending,
        CutStatus.Approved,
        CutStatus.Denied,
        CutStatus.Invoiced,
        CutStatus.Credited,
    ],
    [CutType.FailedCut]: [CutStatus.Void],
    [CutType.DiagnosticCut]: [CutStatus.Void],
};
